// Auto-generated file created by svgr-cli source svg-template.js
// Do not edit directly
import * as React from 'react'
import type { SVGProps } from 'react'
import { Ref, forwardRef, memo } from 'react'
const SvgIconSuccess = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg xmlns='http://www.w3.org/2000/svg' width={props.width || 16} height={props.height || 16} fill='none' viewBox='0 0 24 24' ref={ref} {...props}>
        <path
            fill='currentcolor'
            d='M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10m4.414-11.836-5 5a.934.934 0 0 1-1.324 0l-2.5-2.5a.937.937 0 0 1 1.324-1.324l1.836 1.836 4.336-4.34a.937.937 0 0 1 1.324 1.324z'
        />
    </svg>
)
const ForwardRef = forwardRef(SvgIconSuccess)
const Memo = memo(ForwardRef)
export default Memo
